import { render, staticRenderFns } from "./ECommerceCollectCleanDetail.vue?vue&type=template&id=0c815238&scoped=true&"
import script from "./ECommerceCollectCleanDetail.vue?vue&type=script&lang=js&"
export * from "./ECommerceCollectCleanDetail.vue?vue&type=script&lang=js&"
import style0 from "./ECommerceCollectCleanDetail.vue?vue&type=style&index=0&id=0c815238&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c815238",
  null
  
)

export default component.exports